import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StContainer = styled.div`
  ${({ theme }) => `
    background-color: ${theme.Colors.Background.White};
    border-bottom: 1px solid ${theme.Components.Card.Border};

    @media ${breakpoints.s} {
      padding: ${theme.UI.SpacingPx.Space4} ${theme.UI.SpacingPx.Space6};
    }
    @media ${breakpoints.m} {
      padding: ${theme.UI.SpacingPx.Space4} ${theme.UI.SpacingPx.Space12};
    }

    @media ${breakpoints.l} {
      padding: ${theme.UI.SpacingPx.Space4} ${theme.UI.SpacingPx.Space20};
    }
  `}
`

export { StContainer }
